export const getTokenFromStorage = () => localStorage.getItem('token');

export const getRoleFromStorage = () => localStorage.getItem('role');
